var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3382 12.7408C14.7638 12.3353 15.4326 12.335 15.8586 12.7399L20.2227 16.8882C20.266 16.9293 20.334 16.9293 20.3773 16.8882L24.7414 12.7399C25.1674 12.335 25.8362 12.3353 26.2618 12.7408C26.718 13.1753 26.718 13.9031 26.2618 14.3377L21.1192 19.2366C20.6605 19.6736 19.9395 19.6736 19.4808 19.2366L14.3382 14.3377C13.882 13.9031 13.882 13.1753 14.3382 12.7408Z",
    fill: "#9BD1E8",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3382 19.7408C14.7638 19.3353 15.4326 19.335 15.8586 19.7399L20.2227 23.8882C20.266 23.9293 20.334 23.9293 20.3773 23.8882L24.7414 19.7399C25.1674 19.335 25.8362 19.3353 26.2618 19.7408C26.718 20.1753 26.718 20.9031 26.2618 21.3377L21.1192 26.2366C20.6605 26.6736 19.9395 26.6736 19.4808 26.2366L14.3382 21.3377C13.882 20.9031 13.882 20.1753 14.3382 19.7408Z",
    fill: "#9BD1E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiChevronUp);
export default __webpack_public_path__ + "static/media/mdi_chevron-up.dc41db009e7b6148ea37a95d2374f328.svg";
export { ForwardRef as ReactComponent };